module.exports = __webpack_public_path__ + "static/img/icon_szh_sdnl_ptyy.86308264.png";